import { forwardRef, memo, useEffect, useImperativeHandle, useState } from "react";

import card_dispenser from "../../../../../../assets/games/AmarAkbarAntony/Machine.png"
import historyBaseImg from "../../../../../../assets/games/AmarAkbarAntony/History.png"
import CardCSS from "../../../../../../library/Card/Card";

const AmarAkbarAntonyAnimationLayer = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({
        setJokerCard,
        setJokerToHistory
    }))

    const [jokerCard, setJokerCard] = useState("")
    const [history, setHistory] = useState([...props.history])
    const [isGoToHistory, setJokerToHistory] = useState(false)

    useEffect(() => {

    }, [])

    const getCardTypeClass = (title) => {
        const rank = title.charAt(0);

        if (["A", "2", "3", "4", "5", "6"].includes(rank)) return "amarCard";
        if (["7", "8", "9", "10", "T"].includes(rank)) return "akbarCard";
        if (["J", "Q", "K"].includes(rank)) return "anthonyCard";

        return ""; // fallback
    }

    const afterAnimationEnd = (event) => {
        if (event.animationName === "gotoHistory") {
            setHistory(() => [...props.history])
            setJokerCard("")
            setJokerToHistory(false)
        } else if (event.animationName === "dealPlayerCardCard") {
            props.setPlayerWinner()
        }
    }

    return <div id="AmarAkbarAntonyAnimationLayer">
        <div className="AAA_historyBox">
            <div className="AAA_HistoryCards">
                {history.map((ele, idx) => {
                    return <CardCSS index={1 - (history.length-1 - idx) * 0.1} newClassName="AAA_history_card" key={ele.handId} cardTitle={ele.result.card}></CardCSS>
                })}
            </div>
            <img className="historyBaseImage" src={historyBaseImg} alt="" />
        </div>
        <div className="AAA_Card_placed_box">
            {Boolean(jokerCard) && <CardCSS newClassName={`AAA_card ${getCardTypeClass(jokerCard)}${isGoToHistory ? " goToHistory" : ""}`} cardTitle={jokerCard} onAnimationEnd={afterAnimationEnd}></CardCSS>}
        </div>
        <div className="AAA_card_dispenser">
            <img className="AAA_cardDispenser_img" src={card_dispenser} alt="" />
        </div>
        <div id="AAA_infoText">{props.infoText}</div>
    </div>
})

export default memo(AmarAkbarAntonyAnimationLayer)